import { render, staticRenderFns } from "./BtnPaymentMethodsInfo.vue?vue&type=template&id=516a330a&"
import script from "./BtnPaymentMethodsInfo.vue?vue&type=script&lang=js&"
export * from "./BtnPaymentMethodsInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports